<template>
  <div>

    <Form ref="formData" :model="formData" :rules="rules" v-if="!success">

      <!-- NAME -->
      <FormItem class="mb-30" prop="name">
        <Input
          type="text"
          v-model="formData.name"
          placeholder="Имя"
        />
      </FormItem>

      <!-- PHONE -->
      <FormItem prop="phone" class="mb-30">
        <Input
          type="text"
          v-mask="'+7(###) ###-##-##'"
          v-model="formData.phone"
          placeholder="Номер телефона"
        />
      </FormItem>

      <FormItem align="center" style="margin-bottom: 0;">
        <Button
          style="width: 100%"
          type="success"
          @click="send_mail()"
          :disabled="disabledSaveButton"
        >Получить консультацию</Button
        >
        <!--<Button type="primary" @click="saveAction()" :disabled="!validForm">Сохранить</Button>-->
      </FormItem>

      <Spin size="large" fix v-if="loading"></Spin>
    </Form>

    <div v-if="success">
      <h2 align="center" style="margin-top: 50px; margin-bottom: 50px">Ваша заявка успешно отправлена!</h2>
    </div>

  </div>
</template>

<script>
    import {server_addr} from "../../http.js";
    import { mask } from "vue-the-mask";


    export default {
        props: ['refPage'],
        directives: {
            mask
        },
        data() {
            return {
                validForm: false,
                isChanged: false,

                url_upload: '/api/v1/lead/',

                success: false,

                rules: {
                    name: [
                        {
                            required: true,
                            message: "Пожалуйста, заполните имя",
                            trigger: "change"
                        }
                    ],
                    phone: [
                        {
                            required: true,
                            min: 17,
                            message: "Пожалуйста, заполните телефон",
                            trigger: "change"
                        }
                    ],
                },

                formData: {
                    name: '',
                    phone: '+7',
                },

                sendData: {
                    subject: 'Заявка на пос терминал',
                    text: '',
                },

                loading: false
            };
        },

        watch: {
            "formData.name": function(val, oldVal) {
                this.validateForm();
                this.isChanged = true;
            },
            "formData.phone": function(val, oldVal) {
                this.validateForm();
                this.isChanged = true;
            }
        },
        computed: {
            disabledSaveButton() {
                return !this.isChanged || !this.validForm;
            }
        },

        methods: {
            validateForm() {
                this.$refs.formData.validate(valid => {
                    this.validForm = valid;
                });
            },

            send_mail: function() {
                const url = server_addr + this.url_upload;

                let phone = this.formData.phone.replace(/[-()\s]/g, "");

                this.loading = true;

                this.$http
                    .post(url, {
                        "name": this.formData.name,
                        "phone": phone,
                        "ref_page": this.refPage

                    })
                    .then(response => {
                        this.success = true;
                    })
                    .finally(() => {
                        this.loading = false;
                    })
                    .catch(error => {
                        this.$Message.error("Произошла ошибка. Обратитесь в службу технической поддержки.");
                    })


            },



        }
    };
</script>

<style></style>



// WEBPACK FOOTER //
// src/apps/integrations/moduleForm.vue